import Trackers from '../index';
import { useContext } from 'react';

const useTrackers = () => useContext(Trackers);

export default useTrackers;
